// removed by extract-text-webpack-plugin
module.exports = {"toggle":"Toggle__toggle___1AQV9","isMultiLine":"Toggle__isMultiLine___fhnS8","isLeft":"Toggle__isLeft___3rGGv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Toggle/Toggle.scss
// module id = 613
// module chunks = 0